import { openIdConnectUrl, accessTokenKey } from "../config";
import BaseConnector from "./baseConnector";

export default class OpenIdConnector extends BaseConnector {
  constructor() {
    super(openIdConnectUrl, accessTokenKey);
  }

  getURL() {
    return this.url;
  }

  static Factory() {
    return () => new OpenIdConnector();
  }
}
